/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateSalesInvoiceDto
 */
export interface CreateUpdateSalesInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    status: CreateUpdateSalesInvoiceDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    paymentForm: CreateUpdateSalesInvoiceDtoPaymentFormEnum;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    invoiceDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    saleDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    dueDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    amountNet?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    amountGross?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    gtuCodeId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    documentCodeIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    parentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    originalInvoiceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    correctionReasonTxt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    additionalNotesTxt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    companyId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    issuerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    recipientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    recipientRole?: CreateUpdateSalesInvoiceDtoRecipientRoleEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    recipientIdWew?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    recipientRoleDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    recipientShare?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    examinedId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    companyNip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    companyTaxIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    examinedNip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    companyAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    examinedAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    approverId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    approvedTs?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    toKsef: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    sendEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    isPaid?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    paidDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    statusKsef?: CreateUpdateSalesInvoiceDtoStatusKsefEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    numberKsef?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    qrCodeKsef?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    qrCodeKsefVerification?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    ksefDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    ksefRejectionReason?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSalesInvoiceDto
     */
    ts?: Date | null;
}


/**
 * @export
 */
export const CreateUpdateSalesInvoiceDtoStatusEnum = {
    Draft: 'Draft',
    Approved: 'Approved',
    InKSeF: 'InKSeF'
} as const;
export type CreateUpdateSalesInvoiceDtoStatusEnum = typeof CreateUpdateSalesInvoiceDtoStatusEnum[keyof typeof CreateUpdateSalesInvoiceDtoStatusEnum];

/**
 * @export
 */
export const CreateUpdateSalesInvoiceDtoPaymentFormEnum = {
    Cash: 'Cash',
    BankTransfer: 'BankTransfer',
    Card: 'Card',
    Mobile: 'Mobile'
} as const;
export type CreateUpdateSalesInvoiceDtoPaymentFormEnum = typeof CreateUpdateSalesInvoiceDtoPaymentFormEnum[keyof typeof CreateUpdateSalesInvoiceDtoPaymentFormEnum];

/**
 * @export
 */
export const CreateUpdateSalesInvoiceDtoRecipientRoleEnum = {
    Factor: 'Factor',
    Recipient: 'Recipient',
    OriginalEntity: 'OriginalEntity',
    AdditionalBuyer: 'AdditionalBuyer',
    PaymentEntity: 'PaymentEntity',
    Payer: 'Payer',
    LocalGovernmentIssuer: 'LocalGovernmentIssuer',
    LocalGovernmentRecipient: 'LocalGovernmentRecipient',
    VATGroupMemberIssuer: 'VATGroupMemberIssuer',
    VATGroupMemberRecipient: 'VATGroupMemberRecipient',
    Employee: 'Employee',
    OtherEntity: 'OtherEntity'
} as const;
export type CreateUpdateSalesInvoiceDtoRecipientRoleEnum = typeof CreateUpdateSalesInvoiceDtoRecipientRoleEnum[keyof typeof CreateUpdateSalesInvoiceDtoRecipientRoleEnum];

/**
 * @export
 */
export const CreateUpdateSalesInvoiceDtoStatusKsefEnum = {
    AcceptedInKSeF: 'AcceptedInKSeF',
    RejectedInKSeF: 'RejectedInKSeF',
    WaitingForKSeF: 'WaitingForKSeF'
} as const;
export type CreateUpdateSalesInvoiceDtoStatusKsefEnum = typeof CreateUpdateSalesInvoiceDtoStatusKsefEnum[keyof typeof CreateUpdateSalesInvoiceDtoStatusKsefEnum];


/**
 * Check if a given object implements the CreateUpdateSalesInvoiceDto interface.
 */
export function instanceOfCreateUpdateSalesInvoiceDto(value: object): value is CreateUpdateSalesInvoiceDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('paymentForm' in value) || value['paymentForm'] === undefined) return false;
    if (!('invoiceDate' in value) || value['invoiceDate'] === undefined) return false;
    if (!('saleDate' in value) || value['saleDate'] === undefined) return false;
    if (!('gtuCodeId' in value) || value['gtuCodeId'] === undefined) return false;
    if (!('documentCodeIds' in value) || value['documentCodeIds'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('toKsef' in value) || value['toKsef'] === undefined) return false;
    if (!('sendEmail' in value) || value['sendEmail'] === undefined) return false;
    return true;
}

export function CreateUpdateSalesInvoiceDtoFromJSON(json: any): CreateUpdateSalesInvoiceDto {
    return CreateUpdateSalesInvoiceDtoFromJSONTyped(json, false);
}

export function CreateUpdateSalesInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateSalesInvoiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'status': json['status'],
        'paymentForm': json['paymentForm'],
        'invoiceDate': (new Date(json['invoiceDate'])),
        'saleDate': (new Date(json['saleDate'])),
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'amountNet': json['amountNet'] == null ? undefined : json['amountNet'],
        'amountGross': json['amountGross'] == null ? undefined : json['amountGross'],
        'gtuCodeId': json['gtuCodeId'],
        'documentCodeIds': json['documentCodeIds'],
        'active': json['active'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'originalInvoiceId': json['originalInvoiceId'] == null ? undefined : json['originalInvoiceId'],
        'correctionReasonTxt': json['correctionReasonTxt'] == null ? undefined : json['correctionReasonTxt'],
        'additionalNotesTxt': json['additionalNotesTxt'] == null ? undefined : json['additionalNotesTxt'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'issuerId': json['issuerId'] == null ? undefined : json['issuerId'],
        'recipientId': json['recipientId'] == null ? undefined : json['recipientId'],
        'recipientRole': json['recipientRole'] == null ? undefined : json['recipientRole'],
        'recipientIdWew': json['recipientIdWew'] == null ? undefined : json['recipientIdWew'],
        'recipientRoleDescription': json['recipientRoleDescription'] == null ? undefined : json['recipientRoleDescription'],
        'recipientShare': json['recipientShare'] == null ? undefined : json['recipientShare'],
        'examinedId': json['examinedId'] == null ? undefined : json['examinedId'],
        'companyNip': json['companyNip'] == null ? undefined : json['companyNip'],
        'companyTaxIdentifier': json['companyTaxIdentifier'] == null ? undefined : json['companyTaxIdentifier'],
        'examinedNip': json['examinedNip'] == null ? undefined : json['examinedNip'],
        'companyAddress': json['companyAddress'] == null ? undefined : json['companyAddress'],
        'examinedAddress': json['examinedAddress'] == null ? undefined : json['examinedAddress'],
        'approverId': json['approverId'] == null ? undefined : json['approverId'],
        'approvedTs': json['approvedTs'] == null ? undefined : (new Date(json['approvedTs'])),
        'toKsef': json['toKsef'],
        'sendEmail': json['sendEmail'],
        'isPaid': json['isPaid'] == null ? undefined : json['isPaid'],
        'paidDate': json['paidDate'] == null ? undefined : (new Date(json['paidDate'])),
        'statusKsef': json['statusKsef'] == null ? undefined : json['statusKsef'],
        'numberKsef': json['numberKsef'] == null ? undefined : json['numberKsef'],
        'qrCodeKsef': json['qrCodeKsef'] == null ? undefined : json['qrCodeKsef'],
        'qrCodeKsefVerification': json['qrCodeKsefVerification'] == null ? undefined : json['qrCodeKsefVerification'],
        'ksefDate': json['ksefDate'] == null ? undefined : (new Date(json['ksefDate'])),
        'ksefRejectionReason': json['ksefRejectionReason'] == null ? undefined : json['ksefRejectionReason'],
        'ts': json['ts'] == null ? undefined : (new Date(json['ts'])),
    };
}

export function CreateUpdateSalesInvoiceDtoToJSON(value?: CreateUpdateSalesInvoiceDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'number': value['number'],
        'status': value['status'],
        'paymentForm': value['paymentForm'],
        'invoiceDate': ((value['invoiceDate']).toISOString()),
        'saleDate': ((value['saleDate']).toISOString()),
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate'] as any).toISOString()),
        'amountNet': value['amountNet'],
        'amountGross': value['amountGross'],
        'gtuCodeId': value['gtuCodeId'],
        'documentCodeIds': value['documentCodeIds'],
        'active': value['active'],
        'parentId': value['parentId'],
        'originalInvoiceId': value['originalInvoiceId'],
        'correctionReasonTxt': value['correctionReasonTxt'],
        'additionalNotesTxt': value['additionalNotesTxt'],
        'companyId': value['companyId'],
        'issuerId': value['issuerId'],
        'recipientId': value['recipientId'],
        'recipientRole': value['recipientRole'],
        'recipientIdWew': value['recipientIdWew'],
        'recipientRoleDescription': value['recipientRoleDescription'],
        'recipientShare': value['recipientShare'],
        'examinedId': value['examinedId'],
        'companyNip': value['companyNip'],
        'companyTaxIdentifier': value['companyTaxIdentifier'],
        'examinedNip': value['examinedNip'],
        'companyAddress': value['companyAddress'],
        'examinedAddress': value['examinedAddress'],
        'approverId': value['approverId'],
        'approvedTs': value['approvedTs'] == null ? undefined : ((value['approvedTs'] as any).toISOString()),
        'toKsef': value['toKsef'],
        'sendEmail': value['sendEmail'],
        'isPaid': value['isPaid'],
        'paidDate': value['paidDate'] == null ? undefined : ((value['paidDate'] as any).toISOString()),
        'statusKsef': value['statusKsef'],
        'numberKsef': value['numberKsef'],
        'qrCodeKsef': value['qrCodeKsef'],
        'qrCodeKsefVerification': value['qrCodeKsefVerification'],
        'ksefDate': value['ksefDate'] == null ? undefined : ((value['ksefDate'] as any).toISOString()),
        'ksefRejectionReason': value['ksefRejectionReason'],
        'ts': value['ts'] == null ? undefined : ((value['ts'] as any).toISOString()),
    };
}

